import { type FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonClose, ButtonWithArray } from '@/components/buttons';
import { Modals } from '@/helpers/modals';
import { useGameThemes } from '@/hooks/game';
import { useNavigation } from '@/hooks/navigation';
import { useModalsStore } from '@/store';

import { ScTopicsSelect } from './styled';

export interface ITopicsProps {
  categoryId?: string;
}

export const Topics: FC<ITopicsProps> = ({ categoryId }) => {
  const { t } = useTranslation('common');
  const { navigate } = useNavigation();
  const open = useModalsStore.use.open();

  const { currentGameTheme } = useGameThemes(categoryId);

  const resetTopic = () => {
    navigate('/', true);
  };

  const handleButtonClick = useCallback(() => {
    open(Modals.Topics);
  }, [open]);

  return (
    <ScTopicsSelect>
      <ButtonWithArray
        onClick={handleButtonClick}
        selected={!!currentGameTheme}
      >
        {currentGameTheme?.title || t('topics.btnAll')}
      </ButtonWithArray>
      {currentGameTheme && (
        <ButtonClose className="close" onClick={resetTopic} right={0} top={0} />
      )}
    </ScTopicsSelect>
  );
};
